import { useMutation, useQueryClient } from '@tanstack/react-query';
import { growthKeys } from '@/data/queryKeys';
import { useGrowthQuery } from '@/data/useGrowthQuery';
import { useNotify } from '@/data/notifications';
import { deploySchema, fetchSchema, markSchemaDeployed } from '../api';

export function useSchema() {
  return useGrowthQuery({
    queryKey: growthKeys.schema(),
    queryFn: fetchSchema,
  });
}

export function useSchemaMutations() {
  const queryClient = useQueryClient();
  const notify = useNotify();

  const install = useMutation({
    mutationFn: deploySchema,
    onSuccess: () => {
      notify.success('Schema deployment queued');
      void queryClient.invalidateQueries({ queryKey: growthKeys.schema() });
    },
    onError: (e) => notify.error(e),
  });

  const markDeployed = useMutation({
    mutationFn: markSchemaDeployed,
    onSuccess: () => {
      notify.success('Schema marked deployed');
      void queryClient.invalidateQueries({ queryKey: growthKeys.schema() });
    },
    onError: (e) => notify.error(e),
  });

  return { install, markDeployed };
}
